import React from 'react';
import { usePermissions } from '../../../contexts/core/PermissionsContext';
import { checkUserLoggedin } from 'stores/Layout/layoutActions';

const RequirePermission = ({ permission, children }) => {
  const { permissions } = usePermissions();
  if (permission == 'show' || !checkUserLoggedin()) {
    return children;
  }
  // Show everything if `allowAll` is true
  if (permissions.allowAll || !permission) {
    return children;
  }

  // Hide everything if permissions is an empty object or permission doesn't exist
  if (!permission || !permissions[permission]) {
    return null;
  }
  if (permission == 'hide') {
    return null;
  }

  // Show content for the specific permission
  return children;
};

export default RequirePermission;
